module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338629/particular02-8423c5e14ad49838ef91b14daf67a8a5.png";